import { Box, Chip, IconButton, Tooltip } from "@mui/material";
import {
  GridColDef,
  GridRenderCellParams,
  GridValueGetterParams,
} from "@mui/x-data-grid";
import React from "react";
import VisibilityIcon from "@mui/icons-material/Visibility";
import PlaylistRemoveIcon from "@mui/icons-material/PlaylistRemove";
import { MatchedProduct } from "../../../../models/features/Integration/DmsSetup";
import AppGrid from "../../../app/AppGrid";
import { useSelector } from "react-redux";
import { AppState } from "../../../../redux/reducer/rootReducer";
import { AppGridId } from "../../../../models/app/AppGridModels";
import { GetAppGridColumns } from "../../../../services/utilities/utility";
import PanToolIcon from "@mui/icons-material/PanTool";
interface MatchingWholegoodsGridProps {
  data: MatchedProduct[];
  isLoading: boolean;
  setFormOpen: any;
  productByIdMutation: any;
  setstock: any;
  setSelectedItem: any;
  setConfirmDialog: any;
}
const MatchingWholegoodsGrid: React.FunctionComponent<
  MatchingWholegoodsGridProps
> = ({
  data,
  isLoading,
  productByIdMutation,
  setFormOpen,
  setConfirmDialog,
  setSelectedItem,
  setstock,
}) => {
  const gridSetting = useSelector((state: AppState) =>
    state?.AppGridReducer?.setting.find(
      (x) => x.gridId === AppGridId.Create_Setup_Matched_Products
    )
  );
  const columns: GridColDef[] = [
    {
      field: "dmsProduct.mfgName",
      headerName: "Dms Manufacturer",
      flex: 1,
      valueGetter: (params: GridValueGetterParams<MatchedProduct>) =>
        params.row.dmsProduct.mfrCode + " - " + params.row.dmsProduct.mfgName,
    },
    {
      field: "dmsProduct.model",
      headerName: "DMS Model",
      flex: 1,
      valueGetter: (params: GridValueGetterParams<MatchedProduct>) =>
        params.row.dmsProduct.model,
    },
    {
      field: "catalogProduct.modelNumber",
      headerName: "Catalog Model Number",
      flex: 1,
      valueGetter: (params: GridRenderCellParams<MatchedProduct>) =>
        params.row.catalogProduct
          ? params.row.catalogProduct?.modelNumber
          : params.row.dmsProduct?.model,
    },
    {
      field: "catalogProduct.productManufacturer?.title",
      headerName: "Catalog Manufacturer",
      flex: 1,
      valueGetter: (params: GridValueGetterParams<MatchedProduct>) =>
        params.row.catalogProduct?.productManufacturer?.title ?? "N/A",
    },
    {
      field: "catalogProduct.title",
      headerName: "Catalog Title",
      flex: 1,
      valueGetter: (params: GridValueGetterParams<MatchedProduct>) =>
        params.row.catalogProduct
          ? params.row.catalogProduct?.title
          : params.row.dmsProduct?.mfrCode + " " + params.row.dmsProduct?.model,
    },
    {
      field: "catalogProduct.sku",
      headerName: "Catalog SKU",
      flex: 1,
      valueGetter: (params: GridValueGetterParams<MatchedProduct>) =>
        params.row.catalogProduct
          ? params.row.catalogProduct?.sku
          : params.row.dmsProduct.model,
    },
    {
      field: "catalogProduct.category.title",
      headerName: "Catalog Category",
      flex: 1,
      valueGetter: (params: GridValueGetterParams<MatchedProduct>) =>
        params.row.catalogProduct
          ? params.row.catalogProduct?.category?.title
          : params.row.dmsProduct.productLine,
    },
    {
      field: "type",
      headerName: "Type",
      flex: 1,
      align: "center",
      headerAlign: "center",
      filterable: false,
      renderCell: (params: GridRenderCellParams) => {
        const isManuallyMatched = params.row.isManuallyMatched;
        return (
          <Box display="flex" alignItems="center" gap={1}>
            {params.row.catalogProduct ? (
              <Chip label="Catalog" color="success" size="small" />
            ) : (
              <Chip label="DMS" color="warning" size="small" />
            )}
            {isManuallyMatched && params.row.catalogProduct && (
              <Tooltip title="This is manually matched product.">
                <PanToolIcon fontSize="small" />
              </Tooltip>
            )}
          </Box>
        );
      },
    },
    {
      field: "dmsProduct.price",
      headerName: "Price ($)",
      align: "right",
      headerAlign: "right",
      flex: 1,
      type: "number",
      // filterable: false,
      valueGetter: (params: GridValueGetterParams<MatchedProduct>) =>
        params.row.dmsProduct?.cost.toFixed(2),
    },
    {
      field: "dmsProduct.count",
      headerName: "Stock",
      align: "right",
      type: "number",
      headerAlign: "right",
      flex: 1,
      filterable: false,
      valueGetter: (params: GridValueGetterParams<MatchedProduct>) => {
        if (params.row?.dmsProduct.locationCount) {
          return params.row?.dmsProduct.locationCount?.reduce(
            (partial: number, value: any) => partial + value.count,
            0
          );
        } else {
          return 0;
        }
      },
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      flex: 1,

      renderCell: (params: GridRenderCellParams) => {
        return (
          <div>
            <IconButton
              id="basic-button"
              onClick={(e) => {
                setFormOpen(true);
                productByIdMutation({
                  data: { id: params.row.catalogProduct.id },
                });
                setstock(params.row.dmsProduct.locationCount);
              }}
            >
              <VisibilityIcon />
            </IconButton>
            |
            <IconButton
              id="basic-button"
              aria-haspopup="true"
              onClick={(e) => {
                setConfirmDialog(true);
                setSelectedItem(params.row);
              }}
            >
              <PlaylistRemoveIcon />
            </IconButton>
          </div>
        );
      },
    },
  ];

  return (
    <AppGrid
      gridId={AppGridId.Create_Setup_Matched_Products}
      data={data
        .filter((n) => n.dmsProduct)
        .map((item, index) => ({ id: index, ...item }))}
      columns={GetAppGridColumns(columns, gridSetting?.columnVisibilityModel)}
      isLoading={isLoading}
      checkBox={true}
      height={598}
    ></AppGrid>
  );
};

export default MatchingWholegoodsGrid;
